import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CurrencyInput from 'react-currency-input-field';

import { crearGasto } from '../../actions/gastos';
import { buscarSucursales } from '../../actions/sucursales';
import { buscarProveedores } from '../../actions/proveedores';
import { buscarMetodosTipo } from '../../actions/metodos';
import { buscarEventos } from '../../actions/eventos';
import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

const statusOpciones = [
    { value: false, label: 'Pendiente' },
    { value: true,  label: 'Pagado' }
];

const adeudadoOpciones = [
    { value: 0, label: 'Daniel' },
    { value: 1, label: 'Socio' }
];

const remobolsadoOpciones = [
    { value: 0, label: 'Aún no' },
    { value: 1, label: 'Pagado con dinero de venta' }
];

const NuevoGasto = ({ show, handleCerrar }) => {

    const dispatch = useDispatch();

    const sucursalesListado = useSelector(state => state.sucursales.listado);
    const proveedoresListado = useSelector(state => state.proveedores.listado);
    const metodosListado = useSelector(state => state.metodos.listado);
    const eventosListado = useSelector(state => state.eventos.listado);

    const [gastoData, setGastoData] = useState({
        sucursal: null,
        evento: null,
        proveedor: null,
        metodo: null,
        fecha: null,
        concepto: null,
        total: null,
        status: null,
        adeudado: null,
        remobolsado: null
    });

    const [sucursalData, setSucursalData] = useState(null);
    const [eventoData, setEventoData] = useState(null);
    const [eventoFijado, setEventoFijado] = useState(false);
    const [proveedorData, setProveedorData] = useState(null);
    const [metodoData, setMetodoData] = useState(null);
    const [statusGastoData, setStatusGastoData] = useState(null);
    const [adeudadoData, setAdeudadoData] = useState(null);
    const [remobolsadoData, setRemobolsadoData] = useState(null);
    const [statusProcesar, setStatusProcesar] = useState(false);

    useEffect(() => {
        dispatch(buscarSucursales());
        dispatch(buscarProveedores());
        dispatch(buscarMetodosTipo(5));
        dispatch(buscarEventos(true));
    }, []);

    const handleInputChange = ({ target }) => {
        setGastoData({ ...gastoData, [target.name]: target.value });
    };

    const handleSelectSucursal = (option) => {
        setSucursalData(option);

        if (option) {
            const sucursal = sucursalesListado.find(s => s._id === option.value);
            if (sucursal?.evento) {
                const ev = { value: sucursal.evento._id, label: sucursal.evento.nombre };
                setEventoData(ev);
                setEventoFijado(true);
                setGastoData({ ...gastoData, sucursal: option.value, evento: sucursal.evento._id });
            } else {
                setEventoFijado(false);
                setGastoData({ ...gastoData, sucursal: option.value });
            }
        } else {
            setEventoFijado(false);
            setGastoData({ ...gastoData, sucursal: null });
        }
    };

    const handleSelectEvento = (option) => {
        setEventoData(option);
        setGastoData({ ...gastoData, evento: option?.value ?? null });
    };

    const handleSelectProveedor = (option) => {
        setProveedorData(option);
        setGastoData({ ...gastoData, proveedor: option?.value ?? null });
    };

    const handleSelectMetodo = (option) => {
        setMetodoData(option);
        setGastoData({ ...gastoData, metodo: option?.value ?? null });
    };

    const handleDatePicker = (name, value) => {
        setGastoData({ ...gastoData, [name]: value });
    };

    const handleNumberChange = (value, name) => {
        setGastoData({ ...gastoData, [name]: value || '' });
    };

    const handleSelectStatus = (option) => {
        setStatusGastoData(option);
        setGastoData({ ...gastoData, status: option != null ? option.value : null });
    };

    const handleSelectAdeudado = (option) => {
        setAdeudadoData(option);
        setGastoData({ ...gastoData, adeudado: option?.value ?? null });
    };

    const handleSelectRemobolsado = (option) => {
        setRemobolsadoData(option);
        setGastoData({ ...gastoData, remobolsado: option?.value ?? null });
    };

    const handleClose = () => {
        setGastoData({ sucursal: null, evento: null, proveedor: null, metodo: null, fecha: null, concepto: null, total: null, status: null, adeudado: null, remobolsado: null });
        setSucursalData(null);
        setEventoData(null);
        setEventoFijado(false);
        setProveedorData(null);
        setMetodoData(null);
        setStatusGastoData(null);
        setAdeudadoData(null);
        setRemobolsadoData(null);
        handleCerrar();
    };

    const handleSubmit = async () => {
        setStatusProcesar(true);
        await dispatch(crearGasto(gastoData));
        setStatusProcesar(false);
        handleClose();
    };

    const sucursalesOpciones = sucursalesListado.map(s => ({ value: s._id, label: s.nombre }));
    const eventosOpciones = (eventosListado || []).map(e => ({ value: e._id, label: e.nombre }));
    const proveedoresOpciones = proveedoresListado.map(p => ({ value: p._id, label: p.nombre }));
    const metodosOpciones = metodosListado.map(m => ({ value: m._id, label: m.nombre }));

    return (
        <Modal show={show} backdrop="static" centered onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Nuevo gasto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="sucursal"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Sucursal"
                                options={sucursalesOpciones}
                                value={sucursalData}
                                onChange={handleSelectSucursal}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="evento"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Evento"
                                options={eventosOpciones}
                                value={eventoData}
                                onChange={handleSelectEvento}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                                isDisabled={eventoFijado}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="proveedor"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Proveedor"
                                options={proveedoresOpciones}
                                value={proveedorData}
                                onChange={handleSelectProveedor}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <Select
                            name="metodo"
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder="Método de pago"
                            options={metodosOpciones}
                            value={metodoData}
                            onChange={handleSelectMetodo}
                            menuPortalTarget={document.body}
                            components={{ ValueContainer: CustomValueContainer }}
                            styles={{ ...styles_select }}
                            isClearable
                        />
                    </div>
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <DatePicker
                                    className="form-control text-center input-datepicker"
                                    selected={gastoData.fecha}
                                    onChange={(date) => handleDatePicker('fecha', date)}
                                    dateFormat="dd/MM/yyyy"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    autoComplete="off"
                                />
                                <label className="label-datepicker">Fecha</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="form-floating">
                            <CurrencyInput
                                className="form-control"
                                placeholder="Total"
                                id="total"
                                name="total"
                                value={gastoData.total || ''}
                                onValueChange={(value, name) => handleNumberChange(value, name)}
                                prefix="$"
                                decimalsLimit={2}
                                groupSeparator=","
                                decimalSeparator="."
                            />
                            <label htmlFor="total">Total</label>
                        </div>
                    </div>
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="status"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Status"
                                options={statusOpciones}
                                value={statusGastoData}
                                onChange={handleSelectStatus}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="adeudado"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="A quien se debe"
                                options={adeudadoOpciones}
                                value={adeudadoData}
                                onChange={handleSelectAdeudado}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="remobolsado"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Reembolso"
                                options={remobolsadoOpciones}
                                value={remobolsadoData}
                                onChange={handleSelectRemobolsado}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <textarea className="form-control textareCampo" placeholder="Concepto" id="concepto" name="concepto" value={gastoData.concepto || ''} onChange={handleInputChange}></textarea>
                                <label htmlFor="concepto">Concepto</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose} disabled={statusProcesar}>
                    Cancelar
                </button>
                {
                    statusProcesar
                        ? <button className="btn btn-success" disabled><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Guardando</button>
                        : <button className="btn btn-success" onClick={handleSubmit}><i className="fas fa-check me-1"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default NuevoGasto;
